<template>
  <div id="HeaderNotinOne" v-if="NOTARIA && NOTARIA.Theme" v-scroll="onScroll">
    <v-app-bar :absolute="!NOTARIA.Theme.Menu.Fixed" scroll-behavior="elevate" 
      :class="'header-one-page-nav-notin default-header-notin menu-header-notin v-app-bar '+(NOTARIA.Theme.Menu.Transparent?'transparent':'')+scrolled" v-if="!drawer"
      :style="marginTopHeader">


      <NuxtLink v-if="!NOTARIA.Theme.Menu.LogoClickAction || NOTARIA.Theme.Menu.LogoClickAction === 0" :to="getLocalePath('/')" class="header-logo logo">
        <img :alt="'Logo ' + NOTARIA.Nombre" :src="imagenIDtoSRC(NOTARIA.Theme.Menu.Logo)" />
      </NuxtLink>
      <div v-else class="header-logo logo" @click="dialogLogo = true" style="cursor: pointer; display: flex; align-items: center;">
        <img :alt="'Logo ' + NOTARIA.Nombre" :src="imagenIDtoSRC(NOTARIA.Theme.Menu.Logo)" />
      </div>
      <v-spacer></v-spacer>

      <nav class="hidden-sm-and-down">

        <v-btn class="theme--light"
          :title="$t(store.ModoAccesible ? 'DesactivarModoAccesibilidad' : 'ActivarModoAccesibilidad')" :ripple="false"
          text :aria-label="(store.ModoAccesible ? 'Desactivar' : 'Activar') + ' Modo Accesibilidad'"
          @click="store.toggleModoAccesible"
          v-if="NOTARIA.Personalizar.Accesibilidad"><v-icon>mdi-human</v-icon></v-btn>

        <v-btn id="btn-inicio" class="theme--light" :ripple="false" text :to="getLocalePath('/')" v-if="NOTARIA.Theme.Menu.ShowInicio">{{getTitleItem('Inicio') }}</v-btn>

        <v-btn id="btn-notario" class="theme--light" :ripple="false" text :to="getLocalePath('/notarios')" v-if="NOTARIA.Theme.Menu.ShowNotarios">{{getTitleItem('Notario') }}</v-btn>

        <v-btn id="btn-equipo" class="theme--light" :ripple="false" text :to="getLocalePath('/equipo')" v-if="NOTARIA.Theme.Menu.ShowEquipo">{{ getTitleItem('Equipo') }}</v-btn>

        <v-btn id="btn-servicios" class="theme--light" :ripple="false" text :to="getLocalePath('/servicios')" v-if="NOTARIA.Theme.Menu.ShowServicios">{{ getTitleItem('Servicios') }}</v-btn>

        <v-btn id="btn-blog" class="theme--light" :ripple="false" text :to="getLocalePath('/blog')" v-if="NOTARIA.Theme.Menu.ShowBlog"> {{ getTitleItem('Blog') }}</v-btn>

        <v-btn id="btn-gallery" class="theme--light" :ripple="false" text :to="getLocalePath('/gallery')" v-if="NOTARIA.Theme.Menu.ShowGallery">{{ getTitleItem('Gallery') }}</v-btn>

        <v-btn if="btn-nv" class="theme--light" :ripple="false" text :href="NOTARIA.NotariaVirtualFrame ? getLocalePath('/NotariaVirtual'): formatUrl(NOTARIA.NotariaVirtual)" target="_blank"
          v-if="NOTARIA.Theme.Menu.ShowNV && NOTARIA.NotariaVirtual"> {{ getTitleNV() }} </v-btn>

        <v-btn id="btn-solicitud" class="theme--light" :ripple="false" text :to="enlaceSolicitud('menu')" v-if="accesoSolicitud.visible('menu') && !accesoSolicitud.menuDestacado.value">{{ tSolicitud('Encargo online') }}</v-btn>

        <v-btn id="btn-contacto" class="theme--light" :ripple="false" text :to="getLocalePath('/contacto')" v-if="NOTARIA.Theme.Menu.ShowContacto">{{ getTitleItem('Contacto') }}</v-btn>

        <v-btn id="btn-solicitud-destacado" class="btn-solicitud-destacado" :ripple="false" variant="flat" color="primary" rounded="pill"
          :to="enlaceSolicitud('menu')" v-if="accesoSolicitud.visible('menu') && accesoSolicitud.menuDestacado.value">{{ tSolicitud('Encargo online') }}</v-btn>

        <a v-if="NOTARIA.Theme.Menu.ShowButton" class="rn-btn button-header-notin"
          :to="NOTARIA.Theme.Menu.Button.Click">
          <span>{{ NOTARIA.Theme.Menu.Button.Texto }}</span>
        </a>
        <span v-if="NOTARIA.Personalizar.Multilenguaje">
        <v-menu>
          <template v-slot:activator="{ props: menu }">
            <v-tooltip location="top" :aria-label="$t('seleccionIdioma')">
              <template v-slot:activator="{ props: tooltip }">
                <v-btn
                  color="primary"
                  v-bind="mergeProps(menu, tooltip)"
                  :aria-label="$t('seleccionIdioma')"
                >
                  <!-- <img :src="compRuteFlag" width="16" :alt="$t('imagenIdioma')" /> -->
                  <IconoIdioma :flag="store.getFlag" />
                  <v-icon small :alt="$t('seleccionIdioma')">mdi-chevron-down</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('seleccionIdioma') }}</span>
            </v-tooltip>
          </template>
          <v-list>
            <v-list-item v-for="entry in compLanguajes" :key="entry.title" @click="changeLocale(entry)"
              :aria-label="$t('seleccionIdioma')+entry.title"  role="button">
              <template v-slot:prepend>
                <!-- <img :src="'/img/' + entry?.Flag + '.png'" width="16"  :alt="$t('imagenIdioma')" /> -->
                <IconoIdioma :flag="entry.Flag" />
              </template>
              <v-list-item-title class="pl-2">{{ entry.Title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
          
        </span>

      </nav>
      <v-app-bar-nav-icon aria-label="Menú" title="Menú" class="ma-0 pa-0 hidden-md-and-up" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer class="hidden-md-and-up header-one-page-nav-drawer-notin menu-header-notin pt-12"
      :color="NOTARIA.Theme.Menu.Fondo && NOTARIA.Theme.Menu.Fondo.Color" v-model="drawer" bottom temporary
      v-if="drawer && NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Menu" fixed width="320">
      <nav>
        <v-btn absolute class="mt-0 boton-cerrar-drawer" aria-label="Cerrar menú navegacion" icon @click="drawer = !drawer" v-html="iconSvg(closeIcon)"/>
        <v-list>
          <v-list-item :ripple="false" key="Accesibilidad" @click="store.toggleModoAccesible()" link
            aria-label="Accesibilidad" v-if="NOTARIA.Personalizar.Accesibilidad"
            :title="$t(store.ModoAccesible ? 'DesactivarModoAccesibilidad' : 'ActivarModoAccesibilidad')">
          </v-list-item>

          <v-list-item :ripple="false" key="Inicio" :to="getLocalePath('/')" link aria-label="Ir a inicio"
            v-if="NOTARIA.Theme.Menu.ShowInicio" :title="getTitleItem('Inicio')">
          </v-list-item>

          <v-list-item :ripple="false" key="Notarios" :to="getLocalePath('/notarios')" link v-if="NOTARIA.Theme.Menu.ShowNotarios"
            :title="getTitleItem('Notario')">
          </v-list-item>

          <v-list-item :ripple="false" key="Equipo" :to="getLocalePath('/equipo')" link v-if="NOTARIA.Theme.Menu.ShowEquipo"
            :title="getTitleItem('Equipo')">
          </v-list-item>

          <v-list-item :ripple="false" key="Servicios" :to="getLocalePath('/servicios')" link v-if="NOTARIA.Theme.Menu.ShowServicios"
            :title="getTitleItem('Servicios')">
          </v-list-item>

          <v-list-item :ripple="false" key="Blog" :to="getLocalePath('/blog')" link v-if="NOTARIA.Theme.Menu.ShowBlog"
            :title="getTitleItem('Blog')">
          </v-list-item>

          <v-list-item :ripple="false" key="Gallery" :to="getLocalePath('/gallery')" link v-if="NOTARIA.Theme.Menu.ShowGallery"
            :title="getTitleItem('Gallery')">
          </v-list-item>

          <v-list-item :ripple="false" key="NV" target="_blank"  :href="NOTARIA.NotariaVirtualFrame ? getLocalePath('/NotariaVirtual'): formatUrl(NOTARIA.NotariaVirtual)" link
            v-if="NOTARIA.Theme.Menu.ShowNV && NOTARIA.NotariaVirtual" :title="getTitleNV()">
          </v-list-item>

          <v-list-item :ripple="false" key="Solicitud" :to="enlaceSolicitud('menu')" link v-if="accesoSolicitud.visible('menu')"
            :class="{ 'solicitud-destacada-movil': accesoSolicitud.menuDestacado.value }"
            :title="tSolicitud('Encargo online')">
          </v-list-item>

          <v-list-item :ripple="false" key="Contacto" :to="getLocalePath('/contacto')" link v-if="NOTARIA.Theme.Menu.ShowContacto"
            :title="getTitleItem('Contacto')">
          </v-list-item>

        </v-list>
        <span v-if="NOTARIA.Personalizar.Multilenguaje">
          <v-btn icon :title="entry.Title" v-for="entry in compLanguajes" :ripple="false" text :key="entry.Title"
            @click="changeLocale(entry)" class="ma-1"  :aria-label="$t('seleccionIdioma')+entry.Title">
            <IconoIdioma :flag="entry.Flag" />
            <!-- <img :src="compRuteFlag"  :alt="$t('imagenIdioma')" width="16" /> -->
          </v-btn>
        </span>
      </nav>

    </v-navigation-drawer>

    <!-- End top header navbar -->

    <v-dialog v-model="dialogLogo" max-width="90%" content-class="dialog-logo-ampliado" @click:outside="dialogLogo = false">
      <v-card color="transparent" elevation="0" class="d-flex flex-column align-center justify-center pa-4 position-relative">
        <v-btn icon @click="dialogLogo = false" class="btn-cerrar-logo mb-4" color="white" style="background: rgba(0,0,0,0.5);">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <img :src="imagenIDtoSRC(NOTARIA.Theme.Menu.Logo)" style="max-height: 80vh; max-width: 100%; object-fit: contain;" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { ref, computed, mergeProps } from 'vue'
import feather from "feather-icons";
const route = useRoute()

import { useStore } from '../../store/index.ts'
const store = useStore()

import { useUtils } from '#imports';
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()

const { NOTARIA} = storeToRefs(store)

// Acceso al encargo online (se activa en el panel: Trámites online → Configuración)
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t as tSolicitud } from '../../composables/solicitudTextos'
const accesoSolicitud = useAccesoSolicitud()
const enlaceSolicitud = (origen) => accesoSolicitud.enlace(origen)

const drawer = ref(false)
const dialogLogo = ref(false)
const icon = ref("menu")
const closeIcon = ref("x")
const scrolled = ref('')

const marginTopHeader = computed(() => {
  if (store.NOTARIA?.Theme?.DatosContacto?.MostrarStickyBar) {
    if (scrolled.value.includes('top0') && !store.NOTARIA.Theme.DatosContacto.Fixed) {
      return { '--header-margin-top': '0px', marginTop: '0px', transition: 'margin-top 0.3s' }
    }
    return { '--header-margin-top': '30px', marginTop: '30px', transition: 'margin-top 0.3s' }
  }
  return { '--header-margin-top': '0px', marginTop: '0px', transition: 'margin-top 0.3s' }
})

const compLanguajes = computed(() => {
  return store.languages//?.filter(l => l.IsSelected) ?? []
})

const compLanguage = computed({
  get(){
    if(store.getIdioma)
    {
      return store.languages?.find(l => store.getIdioma == l.Flag)
    }
  },
  set(v){
    addIdioma(v.Flag)
  }
})


async function addIdioma(lang)
{
  await store.setIdioma(lang)
}

function iconSvg(icon) {
  return feather.icons[icon].toSvg();
}
async function changeLocale(locale) {
  var routeSplited = route.fullPath.split('/');
  const defaultLang = store.languages && store.languages.length > 0 ? store.languages[0].Language : 'es';
  
  if (locale.Language == defaultLang) {
    if (routeSplited[1]?.length == 2 && store.languages.some(l => l.Language === routeSplited[1])) {
      routeSplited.splice(1, 1);
    }
  } else {
    const currentIsDefault = routeSplited[1]?.length != 2 || !store.languages.some(l => l.Language === routeSplited[1]);
    if (currentIsDefault) {
      routeSplited.splice(1, 0, locale.Language);
    } else {
      routeSplited[1] = locale.Language;
    }
  }
  
  compLanguage.value = locale;
  var newRoute = routeSplited.join('/') || '/';
  location.href = location.origin + newRoute;
}

function getTitleItem(value) {
  switch (value) {
    case "Gallery":
      return store.NOTARIA.Theme.Gallery.Titulo && store.NOTARIA.Theme.Gallery.Titulo.Texto ? store.NOTARIA.Theme.Gallery.Titulo.Texto : $t('Galeria')
    case "Blog":
      return store.NOTARIA.Theme.Blog.Titulo && store.NOTARIA.Theme.Blog.Titulo.Texto ? store.NOTARIA.Theme.Blog.Titulo.Texto : $t('Blog')
    case "Contacto":
      return store.NOTARIA.Theme.Contacto.Titulo && store.NOTARIA.Theme.Contacto.Titulo.Texto ? store.NOTARIA.Theme.Contacto.Titulo.Texto : $t('Contacto')
    case "Servicios":
      return store.NOTARIA.Theme.Servicios.Titulo && store.NOTARIA.Theme.Servicios.Titulo.Texto ? store.NOTARIA.Theme.Servicios.Titulo.Texto : $t('Servicios')
    case "Equipo":
      return store.NOTARIA.Theme.Team.Titulo && store.NOTARIA.Theme.Team.Titulo.Texto ? store.NOTARIA.Theme.Team.Titulo.Texto : $t('Equipo')
    case "Notario":
      if (store.NOTARIA.Notarios.length == 1)
        return store.NOTARIA.Theme.Notarios.Titulo && store.NOTARIA.Theme.Notarios.Titulo.Texto ? store.NOTARIA.Theme.Notarios.Titulo.Texto : $t('Notario')
      else if (store.NOTARIA.Notarios.length > 1)
        return store.NOTARIA.Theme.Notarios.Titulo && store.NOTARIA.Theme.Notarios.Titulo.Texto ? store.NOTARIA.Theme.Notarios.Titulo.Texto : $t('Notarios')
    case "Inicio":
      return store.NOTARIA.Theme.Home.Titulo && store.NOTARIA.Theme.Home.Titulo.Texto ? store.NOTARIA.Theme.Home.Titulo.Texto : $t('Inicio')
  }
}
function onScroll(e) {
  if (typeof window === "undefined") return;
  const top = window.scrollY || 0;
  var r =  '';
  if(top > 0){
    if(store.NOTARIA.Theme.Menu.Fixed){
      var r = " v-app-bar--is-scrolled"
    }
    if(!store.NOTARIA.Theme.DatosContacto.Fixed){
      r += ' top0'
    }
  }
  
  scrolled.value = r
}
function getTitleNV()
{
  if(!store.NOTARIA.Theme.Menu.NameWeb)
  {
    return $t('NotariaVirtual') 
  }else if(store.NOTARIA.Theme.Menu.NameWeb.toUpper == "NOTARÍA VIRTUAL" || store.NOTARIA.Theme.Menu.NameWeb.toUpper == "NOTARIA VIRTUAL"
          || store.NOTARIA.Theme.Menu.NameWeb.toUpper == "NOTARIAVIRTUAL")
  {
    return $t('NotariaVirtual') 
  }else
  {
    return store.NOTARIA.Theme.Menu.NameWeb
  }
}
function formatUrl(url) {
  if (!url) return '';
  if (!/^https?:\/\//i.test(url)) return 'http://' + url;
  return url;
}
</script>
<style lang="scss">
.boton-cerrar-drawer{
  position: absolute;
  right: 15px;
  top: 15px;
  z-index: 99999;
}
.top0{
  top:0 !important;
}
/* Encargo online como botón destacado (panel: Encargos online → Configuración → Accesos en la web) */
.menu-header-notin .v-btn.btn-solicitud-destacado{
  background-color: rgb(var(--v-theme-primary)) !important;
  color: rgb(var(--v-theme-on-primary)) !important;
  margin: 0 8px;
  padding: 0 20px;
  text-transform: none;
  font-weight: 600;
}
.solicitud-destacada-movil{
  background-color: rgb(var(--v-theme-primary));
  color: rgb(var(--v-theme-on-primary)) !important;
  border-radius: 999px;
  margin: 8px 12px;
}
</style>